import { useQuery, gql } from '@apollo/client';

const CAN_MANAGE_PARTNERSHIPS = gql`
  query CanManagePartnerships {
    canManagePartnerships
  }
`;

/**
 * May this person keep the organisation's partnership record current — the delivery audit its
 * supporters read, and the description of the communities they support?
 *
 * **The server's own answer, not a role name.** The gate behind it is the
 * `MANAGE_PARTNERSHIPS` capability, and which role carries it is per-organisation data edited
 * on `/admin/roles` — so any list of role names kept on this side is a copy that silently goes
 * stale. This is the same lesson `useCanAccessLeadership` records.
 *
 * Both screens were previously reachable only by `isAdmin`, which made describing a partnership
 * something only a full data administrator could do. Administering an organisation and speaking
 * for it are different authorities.
 */
export const useCanManagePartnerships = (): boolean => {
  const { data, loading, error } = useQuery(CAN_MANAGE_PARTNERSHIPS);
  if (loading || error) return false;
  return data?.canManagePartnerships === true;
};
